import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
// import { Observable } from 'rxjs/Observable';

// import { Product } from '../products/product';

import { CartItem } from './cart-item';
import { CartService } from './cart.service';
export class CartComponent implements OnInit {
    cartItems: CartItem[];
    cartGrandTotal: number;
/**
 * @param {?} cartService
 * @param {?} location
 * @param {?} router
 */
constructor(
private cartService: CartService,
private location: Location,
private router: Router
    ) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
    }
/**
 * @param {?} index
 * @return {?}
 */
decreaseQuantity(index: number) {
        this.cartService.decreaseQuantity(index);
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
        this.cartItems;
    }
/**
 * @param {?} index
 * @return {?}
 */
increaseQuantity(index: number) {
        this.cartService.increaseQuantity(index);
        this.cartItems = this.cartService.get();
        this.cartGrandTotal = this.cartService.getTotalBeforeTax();
    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @return {?}
 */
checkout(): void {
        this.router.navigate(['/checkout']);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-cart',
    template: "﻿<div class=\"cart\"> <h2>Shopping Cart</h2> <div class=\"cart-items\"> <div *ngFor=\"let cartItem of cartItems\"> <span>{{cartItem.product.name}} ${{cartItem.product.price}} Qty:{{cartItem.quantity}} SubTotal:{{cartItem.quantity * cartItem.product.price}}</span> <!-- <button (click)=\"removeProduct(cartItem.index)\" style=\"font-weight:bold\">X</button> --> <span (click)=\"increaseQuantity(cartItem.index)\" class=\"glyphicon glyphicon-plus\"></span> <span (click)=\"decreaseQuantity(cartItem.index)\" class=\"glyphicon glyphicon-minus\"></span> </div> </div> <span style=\"font-weight:bold;font-style:italic\">Total Before Tax:{{cartGrandTotal}}</span><br/> <span style=\"font-size:smaller;font-style:italic\">Taxes will be calculated based on your address after you enter shipping information.</span><br /> <button (click)=\"goBack()\">Back</button> <button *ngIf=\"cartItems.length > 0\" (click)=\"checkout()\">Checkout</button> </div>",
    styles: ["﻿label { display: inline-block; width: 3em; margin: .5em 0; color: #607D8B; font-weight: bold; } input { height: 2em; font-size: 1em; padding-left: .4em; } button { margin-top: 20px; font-family: Arial; background-color: #eee; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; cursor: hand; } button:hover { background-color: #cfd8dc; } button:disabled { background-color: #eee; color: #ccc; cursor: auto; } .selected { border: double; border-width: thick; } .cart-items { list-style-type: none; padding: 0em; margin: 0em; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CartService, },
{type: Location, },
{type: Router, },
];
}

function CartComponent_tsickle_Closure_declarations() {
/** @type {?} */
CartComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CartComponent.ctorParameters;
/** @type {?} */
CartComponent.prototype.cartItems;
/** @type {?} */
CartComponent.prototype.cartGrandTotal;
/** @type {?} */
CartComponent.prototype.cartService;
/** @type {?} */
CartComponent.prototype.location;
/** @type {?} */
CartComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
